import React from 'react';

const SiteTermsPage: React.FC = () => {
  return (
    <iframe
      src="https://m.media-amazon.com/images/G/01/swiship-ui/Swiship_Site_Terms._CB1758575453_.pdf"
      width="100%"
      height="100%"
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        border: 'none',
        margin: 0,
        padding: 0
      }}
      title="Site Terms"
    />
  );
};

export default SiteTermsPage;
